import React, { Component } from 'react';
import { connect } from 'react-redux';

import MaskedInput from 'react-text-mask';

import ErrorMessage from '../error_message/ErrorMessage';
import { changeContactAttr, finishPurchase, validatorHandlerBlur } from '../../../actions/purchaseActions';
import { getAddressData } from '../../../apiCalls';

const states = [
  { name: 'Rondônia', value: 'RO' },
  { name: 'Acre', value: 'AC' },
  { name: 'Amazonas', value: 'AM' },
  { name: 'Roraima', value: 'RR' },
  { name: 'Pará', value: 'PA' },
  { name: 'Amapá', value: 'AP' },
  { name: 'Tocantins', value: 'TO' },
  { name: 'Maranhão', value: 'MA' },
  { name: 'Piauí', value: 'PI' },
  { name: 'Ceará', value: 'CE' },
  { name: 'Rio Grande do Norte', value: 'RN' },
  { name: 'Paraíba', value: 'PB' },
  { name: 'Pernambuco', value: 'PE' },
  { name: 'Alagoas', value: 'AL' },
  { name: 'Sergipe', value: 'SE' },
  { name: 'Bahia', value: 'BA' },
  { name: 'Minas Gerais', value: 'MG' },
  { name: 'Espírito Santo', value: 'ES' },
  { name: 'Rio de Janeiro', value: 'RJ' },
  { name: 'São Paulo', value: 'SP' },
  { name: 'Paraná', value: 'PR' },
  { name: 'Santa Catarina', value: 'SC' },
  { name: 'Rio Grande do Sul', value: 'RS' },
  { name: 'Mato Grosso do Sul', value: 'MS' },
  { name: 'Mato Grosso', value: 'MT' },
  { name: 'Goiás', value: 'GO' },
  { name: 'Distrito Federal', value: 'DF' },
].sort((a, b) => a.name.localeCompare(b.name));

class PurchaseContact extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.states = states;
  }

  handleChange(e) {
    if (e.target.name === 'cep' && e.target.value.length === 10) {
      getAddressData(e.target.value);
    }
    this.props.changeContactAttr({ name: e.target.name, value: e.target.value });
  }

  getDestinationName() {
    const destinations = this.props.destinations
    const destination = destinations.find((destination) => destination.slug === this.props.destination)
    const destinationName = destination && destination.name

    return destinationName
  }

  render() {
    const formErrors = this.props.errors.contact;

    return (
      <div className="card-contato-compra">
        <div className="box-item">
          <div className="header-box-item">
            <h3>Dados do contato da compra</h3>
          </div>
          <span className="guidance-box-item">
            Preencha os campos abaixo com seus melhores dados, para recebimento de todas informações a respeito do seu
            seguro viagem.
          </span>
          <form action="" method="" className="form-contato-compra">
            <input type="hidden" name="destination" value={this.getDestinationName()} data-perry-destination />
            <input type="hidden" name="departure_date" value={this.props.departure_date} data-perry-departure-date />
            <input type="hidden" name="return_date" value={this.props.return_date} data-perry-return-date />

            <div className="row-contatos">
              <div className="grupo-campo gcontato">
                <input
                  type="text"
                  name="contact_name"
                  value={this.props.contact.contact_name}
                  placeholder="Contato"
                  className={formErrors.contact_name ? 'with-error' : ''}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_name')}
                  data-perry-name
                />
                <ErrorMessage anchor={`contact_contact_name`} field1="contact" field2="contact_name" />
              </div>
              <div className="grupo-campo gemail">
                <input
                  type="text"
                  name="email"
                  value={this.props.contact.email}
                  placeholder="E-mail"
                  className={`desktop${formErrors.email ? ' with-error' : ''}`}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_email')}
                  data-perry-email
                />
                <ErrorMessage anchor={`contact_email`} field1="contact" field2="email" />
              </div>
              <div className="grupo-campo g-telefone">
                <MaskedInput
                  placeholder="Telefone"
                  guide={true}
                  name="phone_number"
                  inputMode="numeric"
                  className={formErrors.phone_number ? 'with-error' : ''}
                  value={this.props.contact.phone_number}
                  mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/]}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_phone')}
                  data-perry-phone
                />
                <ErrorMessage anchor={`contact_phone_number`} field1="contact" field2="phone_number" />
              </div>
            </div>

            <div className="row-contatos">
              <div className="grupo-campo gcep">
                <MaskedInput
                  type="text"
                  name="cep"
                  inputMode="numeric"
                  value={this.props.contact.cep}
                  placeholder="CEP"
                  onChange={this.handleChange}
                  guide={true}
                  className={formErrors.cep ? 'with-error' : ''}
                  mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_cep')}
                />
                <ErrorMessage anchor={`contact_cep`} field1="contact" field2="cep" />
              </div>
              <div className="grupo-campo gendereco">
                <input
                  type="text"
                  name="address"
                  value={this.props.contact.address}
                  placeholder="Endereço"
                  onChange={this.handleChange}
                  className={formErrors.address ? 'with-error' : ''}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_address')}
                  maxLength={45}
                />
                <ErrorMessage anchor={`contact_address`} field1="contact" field2="address" />
              </div>
              <div className="grupo-campo gnumero">
                <input
                  type="text"
                  placeholder="Número"
                  name="number"
                  value={this.props.contact.number}
                  onChange={this.handleChange}
                  maxLength="20"
                  className={formErrors.number ? 'with-error' : ''}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_number')}
                />
                <ErrorMessage anchor={`contact_number`} field1="contact" field2="number" />
              </div>
              <div className="grupo-campo gcomplemento">
                <input
                  type="text"
                  name="complement"
                  value={this.props.contact.complement}
                  placeholder="Complemento"
                  className={formErrors.complement ? 'with-error' : ''}
                  onChange={this.handleChange}
                  maxLength="20"
                />
                <ErrorMessage anchor={`contact_complement`} field1="contact" field2="complement" />
              </div>
            </div>

            <div className="row-contatos">
              <div className="grupo-campo gbairro">
                <input
                  type="text"
                  name="district"
                  placeholder="Bairro"
                  className={formErrors.district ? 'with-error' : ''}
                  value={this.props.contact.district}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_district')}
                  maxLength={40}
                />
                <ErrorMessage anchor={`contact_district`} field1="contact" field2="district" />
              </div>
              <div className="grupo-campo gcdade">
                <input
                  type="text"
                  name="city"
                  placeholder="Cidade"
                  className={formErrors.city ? 'with-error' : ''}
                  value={this.props.contact.city}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_city')}
                />
                <ErrorMessage anchor={`contact_city`} field1="contact" field2="city" />
              </div>
              <div className="grupo-campo gestado">
                <select
                  name="state"
                  value={this.props.contact.state}
                  placeholder="Estado"
                  className={formErrors.state ? ' with-error' : ''}
                  onChange={this.handleChange}
                  onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'contact_state')}
                >
                  <option value="">Estado</option>
                  {this.states.map((state, i) => (
                    <option
                      key={i}
                      value={state.value}
                      defaultValue={state.value === this.props.contact.state.toUpperCase()}
                    >
                      {state.name}
                    </option>
                  ))}
                </select>
                <ErrorMessage anchor={`contact_state`} field1="contact" field2="state" />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    contact: state.purchase.contact,
    errors: state.purchase.errors,
    departure_date: state.purchase.quotationParams.departure_date,
    return_date: state.purchase.quotationParams.return_date,
    destination: state.purchase.quotationParams.destination,
    destinations: state.global.destinations || [],
  }),
  {
    changeContactAttr,
    finishPurchase,
    validatorHandlerBlur,
  }
)(PurchaseContact);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_contact/PurchaseContact.jsx